import { useMemo } from 'react';

import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import { useGetDiagnosisCodesSearchQuery } from '~/store/services/clinicalData';
import {
  GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';

export const GroupClassDiagnosisField = ({
  value,
  onChange,
  leftIcon,
  isReadOnly = false,
  placeholder,
}: GroupClassBaseFieldProps<string[]>) => {
  const { data: diagnosesData } = useGetDiagnosisCodesSearchQuery({
    pageSize: 1000,
    searchString: 'F50',
  });

  const diagnosesOptions = useMemo(() => {
    if (!diagnosesData) return [];
    const map = new Map<string, (typeof diagnosesData)[number]>();
    diagnosesData.forEach((diagnosis) => {
      if (!diagnosis.abbreviation) return;
      map.set(diagnosis.abbreviation, diagnosis);
    });
    return Array.from(map.values()).map((diagnosis) => ({
      label: diagnosis.abbreviation,
      value: diagnosis.abbreviation.replace('-', '_'),
    }));
  }, [diagnosesData]);
  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__diagnoses`}
      label="Diagnoses"
    >
      <UniversalSelect
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__diagnoses-select`}
        isSingleSelect={false}
        onChange={(options) => {
          const selectedValues = Array.isArray(options)
            ? options.map((opt) => opt.value)
            : [];

          onChange(selectedValues);
        }}
        leftIcon={leftIcon}
        options={diagnosesOptions}
        placeholder={placeholder}
        isReadOnly={isReadOnly}
        value={diagnosesOptions?.filter((option) =>
          value?.includes(option.value),
        )}
        withCheckBox
        {...(isReadOnly ? { inputValue: value?.join(', ') } : {})}
      />
    </InputGroupV2>
  );
};
